export const SystemOwner = {
  THIRD_PARTY: 'THIRD_PARTY',
  CUSTOMER: 'CUSTOMER'
};

export const SystemOwnerDisplay = {
  [SystemOwner.THIRD_PARTY]: 'Developer Owned',
  [SystemOwner.CUSTOMER]: 'Customer Owned'
};